module.exports = __webpack_public_path__ + "img/frontImage.adfbaf1d.png";